// extracted by mini-css-extract-plugin
export default {"Icon-container":"Icon_Icon-container__0mB-g"};